<div
  class="message-row mb-2"
  [attr.data-test-id]="'message-row-' + index"
  *ngIf="message"
  [ngClass]="{ active: isDropdownOpen }"
>
  <div
    class="message-block"
    [ngClass]="{ 'ms-auto pe-2 flex-row-reverse': isSentByCurrentUser }"
    [attr.data-test-id]="'message-block-' + index"
  >
    <div class="image-wrap" [ngClass]="{ 'order-1': isSentByCurrentUser }">
      <app-small-profile-image
        *ngIf="!isSentByCurrentUser"
        [profileImage]="message.sender.userImage"
        [accountStatus]="message.sender.userStatus"
        [dataTestId]="'message-sender-avatar-' + index"
        [link]="getLink(message.sender)"
      ></app-small-profile-image>
    </div>
    <div class="text-holder align-self-center d-flex ms-2">
      <div class="d-flex flex-direction-column pe-2">
        <p [attr.data-test-id]="'message-sender-' + index">
          <app-profile-link
            *ngIf="!isSentByCurrentUser"
            [status]="message.sender.userStatus"
            [dataTestId]="'message-link'"
            [userId]="message.sender.userId"
            [text]="message.sender.userName"
          ></app-profile-link>
        </p>
        <p class="text-break" [attr.data-test-id]="'message-text-' + index" [innerHTML]="message.text"></p>
        <em class="time" [attr.data-test-id]="'message-send-time-' + index">
          {{ message.dateCreated | date: DATE_TIME_FORMAT_SHORT }}
        </em>
      </div>

      <div class="d-flex flex-direction-column">
        <div
          *ngIf="isSentByCurrentUser"
          ngbDropdown
          container="body"
          placement="bottom-right"
          class="sender-menu d-flex"
          #myDrop
          (openChange)="setDropDownOpenStatus($event)"
          [attr.data-test-id]="'message-actions-' + index"
        >
          <button
            class="btn btn-link hide-caret message-actions"
            [attr.id]="'message-actions-' + index"
            [attr.data-test-id]="'message-actions-menu-' + index"
            ngbDropdownAnchor
            ngbDropdownToggle
          >
            ...
          </button>
          <div ngbDropdownMenu [attr.aria-labelledby]="'message-actions-menu' + index">
            <button (click)="onEditMessage()" ngbDropdownItem [attr.data-test-id]="'edit-message-' + index">
              {{ 'CHAT_MESSAGE_ACTIONS_EDIT_BUTTON_HINT' | translate }}
            </button>
            <button (click)="onRemoveMessage()" ngbDropdownItem [attr.data-test-id]="'remove-message-' + index">
              {{ 'CHAT_MESSAGE_ACTIONS_REMOVE_BUTTON_HINT' | translate }}
            </button>
          </div>
        </div>
        <div *ngIf="isSentByCurrentUser" class="indicator d-flex" [attr.data-test-id]="'message-indicator-' + index">
          <svg-icon *ngIf="message.isRead" src="assets/icons/icon-read.svg" class="icon-read"> </svg-icon>
          <svg-icon *ngIf="!message.isRead" src="assets/icons/icon-delivered.svg" class="icon-delivered"> </svg-icon>
        </div>
      </div>
    </div>
  </div>
</div>
